var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "container mat40 changelog-page" }, [
    _c("div", { staticClass: "changelog-page__header" }, [
      _vm._m(0),
      _vm.lastUpdate
        ? _c("div", { staticClass: "changelog-page__stats" }, [
            _c("span", [_vm._v("Ostatnia aktualizacja:")]),
            _c("strong", [_vm._v(_vm._s(_vm.lastUpdate))]),
          ])
        : _vm._e(),
    ]),
    !_vm.ready
      ? _c("div", { staticClass: "mat32" }, [_vm._m(1)])
      : _vm.entries.length === 0
      ? _c("div", { staticClass: "changelog-page__empty" }, [
          _vm._v(" Brak opublikowanych zmian. "),
        ])
      : _c(
          "div",
          { staticClass: "changelog-page__list" },
          _vm._l(_vm.entries, function (entry, index) {
            return _c("changelog-entry-item", {
              key: entry.id,
              attrs: {
                entry: entry,
                variant: "dark",
                "is-first": index === 0,
                "is-last": index === _vm.entries.length - 1,
              },
            })
          }),
          1
        ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "changelog-page__intro" }, [
      _c("h1", [_vm._v("Lista zmian w systemie Dostartu (changelog)")]),
      _c("p", [
        _vm._v(
          " Śledź na bieżąco aktualizacje platformy DO:ST:AR:TU. Wdrażamy usprawnienia, naprawiamy błędy i dbamy o najwyższą wydajność systemu obsługi zgłoszeń. "
        ),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "admin-header__loading-state" }, [
      _vm._v(" Trwa wczytywanie "),
      _c("div", { staticClass: "mal15 lds-ellipsis" }, [
        _c("div"),
        _c("div"),
        _c("div"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }